/**
 * TraVosレイヤ名型定義
 */
export type TraVosLayerType =
  | "Travos_計測値５分"
  | "Travos_計測値１時間"
  | "Travos_計測値１時間（画像認識型）"
  | "Travos_中央値１時間"
  | "Travos_確定値１時間"
  | "Travos_確定値１時間（画像認識型）"
  | "Travos_交通基本調査区間"
  | "Travos_計測値５分(リアルタイム)"
  | "Travos_計測値１時間(リアルタイム)"
  | "Travos_計測値５分（画像認識型）(リアルタイム)"
  | "Travos_計測値１時間（画像認識型）(リアルタイム)"
  /**
   * TraVos道路種別コード型定義
   */
  | "TEST_Travos_計測値５分";

/**
 * TraVos道路種別コード型定義
 */
export type TraVosRoadType = "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8";

/**
 * TraVosレイヤ詳細格納クラス
 */
export class TraVosLayerName {
  /**
   * TraVosレイヤ名
   */
  layerType: TraVosLayerType;

  /**
   * TraVos道路種別コード
   */
  roadType: TraVosRoadType[];

  /**
   * 時間コード
   */
  timeCode: string;

  /**
   * コンストラクタ
   * @param layerType
   * @param roadType
   * @param timeCode
   */
  constructor(
    layerType: TraVosLayerType,
    roadType: TraVosRoadType[],
    timeCode: string
  ) {
    this.layerType = layerType;
    this.roadType = roadType;
    this.timeCode = timeCode;
  }

  /**
   * TraVosレイヤ物理名を取得する
   */
  getLayerName(): string {
    return this.layerType.replace("(リアルタイム)", "");
  }
}
